export const checkIsAuthenticated = ({ authentication, profile }) => !!(
  authentication && authentication?.loggedIn && profile?.personal.user_wix_id
);
